import AOS from "aos";
import "aos/dist/aos.css";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "../../assets/css/digital.css";
import data from "../ApiUrl/meta_api.js";

import { toast } from "react-toastify";
import pdfFile1 from "../../assets/pdf/Digital Marketing/SkimitarAcademy - Advanced Digital Marketing Strategies -3M.pdf";
import pdfFile2 from "../../assets/pdf/Digital Marketing/SkimitarAcademy - Digital Marketing Mastery -6M.pdf";
import pdfFile from "../../assets/pdf/Digital Marketing/SkimitarAcademy - Digital Marketing Power-Up -1M.pdf";
// import apiUrl from "../Environment/Api.js";

function DigitalMarketing() {
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = () => {
    const serviceMeta = data[0]?.digitalmarketing_page;
    if (serviceMeta) {
      setMeta(serviceMeta);
    }
  };

  useEffect(() => {
    fetchData();
    AOS.init({
      duration: 2000,
      once: true,
    });
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // if (loading) {
  //   return (
  //     <div className="preloader">
  //       <img src={preloader} alt="Loading..." />
  //     </div>
  //   );
  // }

  const [isModalOpen, setIsModalOpen] = useState(false);

  // Function to open the modal
  const Digital_Marketing_Power_Up = () => {
    setIsCourseData("Digital Marketing Power-Up");
    setIsModalOpen(true);
  };

  const Advanced_Digital_Marketing_Strategies = () => {
    setIsCourseData("Advanced Digital Marketing Strategies");
    setIsModalOpen(true);
  };

  const Sensors_and_Actuators = () => {
    setIsCourseData("Digital Marketing Mastery");
    setIsModalOpen(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsCourseData("");
    setIsModalOpen(false);
  };

  const [isCourseData, setIsCourseData] = useState(null);

  // const [selectedCourse, setSelectedCourse] = useState("beginner");

  const formatTime = () => {
    const currentTime = new Date();
    return currentTime.toLocaleTimeString("en-GB", { hour12: false }); // 24-hour format
  };

  const handleSendMessage = async () => {
    const newErrors = {};

    // Validate Name
    if (!formValues.student_name.trim()) {
      newErrors.student_name = "Name is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.student_name)) {
      newErrors.student_name = "Name must contain only letters.";
    }

    // Validate Email
    if (!formValues.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formValues.email)) {
      newErrors.email = "Enter a valid email address.";
    }

    // Validate Mobile
    if (!formValues.mobile_no.trim()) {
      newErrors.mobile_no = "Mobile number is required.";
    } else if (!/^\d{10}$/.test(formValues.mobile_no)) {
      newErrors.mobile_no = "Mobile number must be 10 digits.";
    }

    // Validate Location
    if (!formValues.location.trim()) {
      newErrors.location = "Location is required.";
    } else if (!/^[a-zA-Z\s]+$/.test(formValues.location)) {
      newErrors.location = "Location must contain only letters.";
    }

    // If there are errors, update state and stop submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Clear errors and proceed with API call
    setErrors({});
    console.log("Form Values: ", formValues);

    setIsLoading(true);
    setIsPageDisabled(true);

    try {
      const response = await axios.post(
        // `${apiUrl}/leads_website`,
        {
          ...formValues,
          fetched_course: isCourseData,
          Enquiry_time: formatTime(), // Only send time
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setFormValues({
        student_name: "",
        email: "",
        mobile_no: "",
        location: "",
        Prefered_course: "",
        Source_type: "",
        Enquiry_date: new Date().toISOString().split("T")[0],
        Enquiry_time: "",
      });

      console.log("Data submitted successfully:", response.data);

      if (response.status === 200) {
        console.log("Data submitted successfully:", response.data);
        const fileLinks = {
          "Digital Marketing Power-Up": pdfFile,
          "Advanced Digital Marketing Strategies": pdfFile1,
          "Digital Marketing Mastery": pdfFile2,
        };

        const selectedFile = fileLinks[isCourseData];
        if (selectedFile) {
          setDownloadData({
            fileUrl: selectedFile,
            fileName: isCourseData.replace(/\s+/g, "_").toLowerCase(),
          });
          setIsModalOpen(false);
          setIsPopupOpen(true); // Show the popup
        } else {
          console.error("No file found for the selected course.");
        }

        toast.success("Data Sent Successfully!", {
          position: "top-center",
        });

        setTimeout(() => {
          setIsLoading(false);
          setIsPageDisabled(false);
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("An error occurred while submitting the data. Please try again.");
    } finally {
      // Ensure loader stops after 2 seconds
      setTimeout(() => {
        setIsLoading(false);
        setIsPageDisabled(false);
      }, 2000);
    }
  };

  const [errors, setErrors] = useState({});

  const [formValues, setFormValues] = useState({
    student_name: "",
    email: "",
    mobile_no: "",
    location: "",
    Prefered_course: "",
    source: "Website",
    enquiry_date: new Date().toISOString().split("T")[0],
  });

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormValues((prevState) => ({
  //     ...prevState,
  //     [name]: value,
  //   }));

  //   if (name === "location") {
  //     if (value === "Others") {
  //       setShowOtherLocationField(true);
  //     } else {
  //       setShowOtherLocationField(false);
  //     }
  //   }
  // };

  const handleChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      Prefered_course: isCourseData ? isCourseData : "", // set the specific field you want to update
    }));

    const { name, value } = e.target;
    setFormValues((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "location") {
      if (value === "Others") {
        setShowOtherLocationField(true);
      } else {
        setShowOtherLocationField(false);
      }
    }
  };

  const [showOtherLocationField, setShowOtherLocationField] = useState(false); // State for custom location field
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [downloadData, setDownloadData] = useState(null); // Store the file info

  const handleDownload = () => {
    if (downloadData) {
      const link = document.createElement("a");
      link.href = downloadData.fileUrl;
      link.download = downloadData.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log(`File ${downloadData.fileName} downloaded successfully.`);
      setIsPopupOpen(false); // Close the popup
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [isPageDisabled, setIsPageDisabled] = useState(false);

  return (
    <>
      <Helmet>
        <title>{meta ? meta.title : "Digital Marketing"}</title>
        <link
          rel="canonical"
          href="https://skimitaracademy.com/digitalmarketing"
        />
      </Helmet>

      {isLoading && (
        <div className="loader">
          <img
            className=" responsive-img"
            alt=""
            src={require("../../assets/images/SH Logo.webp")}
          ></img>
        </div>
      )}

      <div className={`page-container ${isPageDisabled ? "blurred" : ""}`}>
        <div
          className="backgroundCommenImage mb-5"
          style={{
            backgroundImage: `url(${require("../../assets/images/Bannar/dm-banner.webp")})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        >
          {" "}
          <div className="backgroundcommenImageBannerText">
            {/* <h1 className="text-danger">Digital Marketing</h1> */}
          </div>
        </div>
        <div className="container  ">
          <div className="row">
            <div className="col-lg-12  " data-aos="fade-up">
              <div className="">
                <h1 className="commomtextcolor text-danger text-center">
                  Digital Marketing Training Program
                </h1>
              </div>
              <div>
                <p className="abc text-start">
                  Our Digital Marketing Course offers a comprehensive, hands-on
                  approach to mastering key marketing strategies for the digital
                  age. Covering SEO, SEM, social media marketing, email
                  marketing, content creation, and analytics, this program
                  provides essential skills to boost online visibility and drive
                  business growth. Learn how to create effective campaigns,
                  analyze data, and stay ahead of trends. Ideal for business
                  owners, marketers, and anyone eager to thrive in the digital
                  world. Join us and gain the expertise to succeed in today’s
                  competitive online landscape.
                </p>
                {/* <button className='btn btn-danger knowmoreservice'>Know More</button> */}
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-1 p-5">
          <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-left">
            <div className="container Expert_led">
              <h2 className="text-start commomtextcolor dM_Para text-danger ">
                Why Choose Our Training Program
              </h2>
              <p className="commonPages dM_Para">
                Our Digital Marketing Training Program offers a comprehensive,
                hands-on approach to mastering the skills necessary for success
                in the digital world. With the constant evolution of online
                platforms, businesses need experts who can leverage the power of
                digital marketing to drive growth. This program covers key areas
                such as SEO, SEM, social media marketing, content creation,
                email marketing, and analytics, providing a well-rounded
                education.
                <br></br>
                <br></br>Through practical exercises and real-world case
                studies, participants gain the knowledge to design and execute
                effective digital marketing strategies. Our experienced
                instructors ensure that the training is up-to-date with the
                latest trends and tools, preparing you to meet the demands of a
                fast-paced industry. Whether you're a business owner, aspiring
                marketer, or professional looking to enhance your skills, this
                program will help you develop a strong online presence, increase
                brand visibility, and boost sales. Join us to unlock your
                potential and stay competitive in the ever-evolving digital
                landscape.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right">
            <img
              className="Training_img mt-5 responsive-img"
              src={require("../../assets/images/Services/Digital Marketing/overworked-workaholic.webp")}
            ></img>
          </div>
        </div>
        {/* our training program start */}
        {/* Our Training Programs */}
        <div className="container our_training_cONtainer">
          <div className="iatHeading text-center">
            <h2 className="text-danger ">Our Training Programs</h2>
            <h4 className="mt-5">
              Explore our diverse range of training programs designed to cater
              to various levels of expertise and industry needs.
            </h4>
          </div>

          <div className="mt-5">
            <div className="row" data-aos="fade-up">
              <div className="col-lg-4 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                <div className="card blogCardSection">
                  <img
                    src={require("../../assets/images/Services/Digital Marketing/map-lying-wooden-table.webp")}
                    className="ImageCardBlog1"
                    alt="Course Image"
                  />
                  <div className="row mt-4 mx-2">
                    <div className="col-lg-12">
                      <p className="blogCardDevelopment ">Digital Marketing</p>
                    </div>
                  </div>
                  <div>
                    <h5 className="text-danger text-center mt-3">
                      Digital Marketing Power-Up
                    </h5>
                    <p className="p-2 commonPages">
                      Digital Marketing Power-Up is designed to supercharge your
                      marketing skills and provide a comprehensive understanding
                      of the most impactful digital marketing tools and
                      strategies.
                    </p>
                  </div>
                  <div>
                    <div className="row p-2">
                      <div className="col-lg-7 col-md-7 col-sm-12">
                        <p>
                          <i className="fa-solid fa-book"></i> Duration - 1
                          month
                        </p>
                      </div>
                      <div className="col-lg-5 col-md-5 col-sm-12 ">
                        <button
                          className="btn btn-success"
                          style={{
                            cursor: "pointer",
                            fontSize: "12px",
                            textTransform: "none",
                          }}
                          onClick={Digital_Marketing_Power_Up}
                        >
                          View Course
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                <div className="card blogCardSection">
                  <img
                    src={require("../../assets/images/Services/Digital Marketing/digital-marketing-with-icons-business-people.webp")}
                    className="ImageCardBlog1"
                    alt="Course Image"
                  />
                  <div className="row mt-4 mx-2">
                    <div className="col-lg-12">
                      <p className="blogCardDevelopment">Digital Marketing</p>
                    </div>
                  </div>
                  <div>
                    <h5 className="text-danger text-center mt-3">
                      Advanced Digital Marketing Strategies
                    </h5>
                    <p className="p-2 commonPages">
                      Advanced Digital Marketing Strategies takes your marketing
                      knowledge to the next level by diving deep into
                      cutting-edge techniques and trends that drive success in
                      the digital world.
                    </p>
                  </div>
                  <div>
                    <div className="row p-2">
                      <div className="col-lg-7 col-md-7 col-sm-12">
                        <p>
                          <i className="fa-solid fa-book"></i> Duration - 3
                          months
                        </p>
                      </div>
                      <div className="col-lg-5 col-md-5 col-sm-12">
                        <button
                          className="btn btn-success "
                          style={{
                            cursor: "pointer",
                            fontSize: "12px",
                            textTransform: "none",
                          }}
                          onClick={Advanced_Digital_Marketing_Strategies}
                        >
                          View Course
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 Our_Training_Programming col-md-6 col-sm-12 mt-3">
                <div className="card blogCardSection">
                  <img
                    src={require("../../assets/images/Services/Digital Marketing/corporate-management-strategy-solution-branding-concept.webp")}
                    className="ImageCardBlog1"
                    alt="Course Image"
                  />
                  <div className="row mt-4 mx-2">
                    <div className="col-lg-12 col-md-6 col-sm-12">
                      <p className="blogCardDevelopment">Digital Marketing</p>
                    </div>
                  </div>
                  <div>
                    <h5 className="text-danger text-center mt-3">
                      Digital Marketing Mastery
                    </h5>
                    <p className="p-2 commonPages">
                      Digital Marketing Mastery is a comprehensive program
                      designed to equip you with the skills and knowledge needed
                      to succeed in today’s fast-paced digital landscape.
                    </p>
                  </div>
                  <div>
                    <div className="row p-2">
                      <div className="col-lg-7 col-md-7 col-sm-12">
                        <p>
                          <i className="fa-solid fa-book"></i> Duration - 6
                          months
                        </p>
                      </div>
                      <div className="col-lg-5 col-md-5 col-sm-12 ">
                        <button
                          className="btn btn-success "
                          style={{
                            cursor: "pointer",
                            fontSize: "12px",
                            textTransform: "none",
                          }}
                          onClick={Sensors_and_Actuators}
                        >
                          View Course
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* our training program end */}

        <div className="container my-5">
          <h2 className="text-center text-danger mb-5">
            Comprehensive Curriculum
          </h2>

          <div className="row align-items-center g-4">
            <div
              className="col-lg-4 col-md-8 mx-auto order-lg-2 order-1 text-center"
              data-aos="zoom-in"
            >
              <img
                src={require("../../assets/images/Services/Digital Marketing/busy-woman-working.webp")}
                className="img-fluid rounded shadow"
                alt="Digital Marketing Curriculum"
                style={{ maxHeight: "400px", objectFit: "cover" }}
              />
            </div>

            {/* Left Side Topics */}
            <div
              className="col-lg-4 col-md-12 order-lg-1 order-2"
              data-aos="fade-right"
            >
              <div className="d-flex align-items-start mb-4">
                <i className="fa-brands fa-searchengin fa-2x text-danger me-3 mt-1"></i>
                <div>
                  <h4 className=" mb-2">Search Engine Optimization (SEO)</h4>
                  <p className=" text-muted mb-0">
                    Master the art of optimizing content for search engines to
                    increase visibility and organic traffic.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-4">
                <i className="fa-brands fa-blogger-b fa-2x text-danger me-3 mt-1"></i>
                <div>
                  <h4 className=" mb-2">Content Marketing</h4>
                  <p className=" text-muted mb-0">
                    Develop skills to create compelling content that attracts
                    and converts your target audience.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start">
                <i className="fa-solid fa-bullhorn fa-2x text-danger me-3 mt-1"></i>
                <div>
                  <h4 className=" mb-2">Social Media Marketing</h4>
                  <p className=" text-muted mb-0">
                    Build a strong brand presence and drive sales on platforms
                    like Facebook, Instagram, LinkedIn, and Twitter with
                    strategic approaches.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Side Topics */}
            <div
              className="col-lg-4 col-md-12 order-lg-3 order-3"
              data-aos="fade-left"
            >
              
              <div className="d-flex align-items-start mb-4">
                <i className="fa-solid fa-file-signature fa-2x text-danger me-3 mt-1"></i>
                <div>
                  <h4 className=" mb-2">Pay-Per-Click (PPC) Advertising</h4>
                  <p className=" text-muted mb-0">
                    Learn how to create, manage, and optimize PPC campaigns for
                    maximum ROI.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start mb-4">
                <i className="fa-regular fa-envelope fa-2x text-danger me-3 mt-1"></i>
                <div>
                  <h4 className=" mb-2">Email Marketing</h4>
                  <p className=" text-muted mb-0">
                    Understand how to build and nurture relationships through
                    effective email campaigns.
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start">
                <i className="fa-solid fa-chart-line fa-2x text-danger me-3 mt-1"></i>
                <div>
                  <h4 className="mb-2">Analytics & Reporting</h4>
                  <p className=" text-muted mb-0">
                    Learn how to measure, analyze, and report on the success of
                    your digital marketing efforts using tools like Google
                    Analytics.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* certificate start */}
        <div className="container mt-4 certificate_COntainer">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12" data-aos="fade-right">
              <h2 className=" Certification_text text-danger h1">
                Certification
              </h2>
              <div className="">
                <p className="commonPages">
                  Upon completion of the course, you’ll receive a certification
                  that is recognized by employers worldwide. This certification
                  demonstrates your proficiency in digital marketing and can
                  help you stand out in the job market or advance in your
                  current role.
                </p>
              </div>

              <div className="">
                <p className="Certification_para commonPages">
                  <span>
                    <i class="fa-solid fa-circle mx-2 Certification_icon"></i>
                  </span>
                  Completing our course doesn't just equip you with in-depth
                  knowledge and practical skills—it also earns you a
                  certification that is respected and recognized by employers
                  worldwide.{" "}
                </p>
              </div>

              <div className="">
                <p className="Certification_para commonPages ">
                  <span>
                    <i class="fa-solid fa-circle mx-2 Certification_icon"></i>
                  </span>
                  Additionally, as the digital marketing industry continues to
                  evolve, having a certification that is up-to-date and aligned
                  with industry standards demonstrates your commitment to
                  continuous learning and professional growth.
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <img
                className="certification_image2 responsive-img"
                alt=""
                src={require("../../assets/images/Services/Digital Marketing/Certification Red.webp")}
              ></img>
            </div>
          </div>
        </div>
        {/* certificate end */}
        {/* Flexible Learning Options start */}
        <div id="description" class="basic-2 py-5">
          <div class="container">
            <div class="row mb-4">
              <div class="col-lg-12 text-center commonPages">
                <h2 className="text-danger">Flexible Learning Options</h2>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-lg-6 col-md-12 col-sm-12 " data-aos="fade-right">
                <ul class="list-unstyled">
                  <li class="media mb-4">
                    <div className="container card_Flexible_Learning  ">
                      <div className="row">
                        <div className="col-lg-2">
                          <div
                            className="card Card_Flexible_Learning bg-danger"
                            data-aos="fade-down"
                          >
                            <i class="text-white d-flex justify-content-center h3 ">
                              1
                            </i>
                          </div>
                        </div>
                        <div className="col-lg-10">
                          <div class="media-body mx-3">
                            <h4 className="backgroundPerson">
                              In-Person Classes
                            </h4>
                            <p className=" " style={{ fontSize: "14px" }}>
                              Access the training materials from anywhere, at
                              any time, with our self-paced online courses.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="media mb-4">
                    <div className="container card_Flexible_Learning  ">
                      <div className="row">
                        <div className="col-lg-2">
                          <div
                            className="card Card_Flexible_Learning bg-danger"
                            data-aos="fade-down"
                          >
                            <i class="text-white d-flex justify-content-center h3 ">
                              2
                            </i>
                          </div>
                        </div>
                        <div className="col-lg-10">
                          <div class="media-body mx-3">
                            <h4 className="backgroundPerson">Online Courses</h4>
                            <p className="" style={{ fontSize: "14px" }}>
                              Access the training materials from anywhere, at
                              any time, with our self-paced online courses.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="media mb-4">
                    <div className="container card_Flexible_Learning ">
                      <div className="row">
                        <div className="col-lg-2">
                          <div
                            className="card Card_Flexible_Learning bg-danger"
                            data-aos="fade-down"
                          >
                            <i class="text-white d-flex justify-content-center h3 ">
                              3
                            </i>
                          </div>
                        </div>
                        <div className="col-lg-10">
                          <div class="media-body mx-3">
                            <h4 className="backgroundPerson">Live Webinars</h4>
                            <p className="" style={{ fontSize: "14px" }}>
                              Participate in live, instructor-led webinars that
                              allow you to ask questions and get real-time
                              feedback.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="col-lg-6 col-md-12 col-sm-12 " data-aos="fade-left">
                <ul class="list-unstyled">
                  <li class="media mb-4">
                    <div className="container card_Flexible_Learning">
                      <div className="row">
                        <div className="col-lg-2">
                          <div
                            className="card Card_Flexible_Learning bg-danger"
                            data-aos="fade-up "
                          >
                            <i class="text-white d-flex justify-content-center h3 ">
                              4
                            </i>
                          </div>
                        </div>
                        <div className="col-lg-10">
                          <div class="media-body mx-3">
                            <h4 className="backgroundPerson">
                              Aspiring Digital Marketers
                            </h4>
                            <p className="" style={{ fontSize: "14px" }}>
                              Beginners who want to start a career in digital
                              marketing.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="media mb-4">
                    <div className="container card_Flexible_Learning">
                      <div className="row">
                        <div className="col-lg-2">
                          <div
                            className="card Card_Flexible_Learning bg-danger"
                            data-aos="fade-up"
                          >
                            <i class="text-white d-flex justify-content-center h3 ">
                              5
                            </i>
                          </div>
                        </div>
                        <div className="col-lg-10">
                          <div class="media-body mx-3">
                            <h4 className="backgroundPerson">
                              Marketing Professionals
                            </h4>
                            <p className="" style={{ fontSize: "14px" }}>
                              Individuals looking to upskill and stay current
                              with the latest digital marketing trends.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="media mb-4">
                    <div className="container card_Flexible_Learning">
                      <div className="row">
                        <div className="col-lg-2">
                          <div
                            className="card Card_Flexible_Learning bg-danger"
                            data-aos="fade-up"
                          >
                            <i class="text-white d-flex justify-content-center h3 ">
                              6
                            </i>
                          </div>
                        </div>
                        <div className="col-lg-10">
                          <div class="media-body mx-3">
                            <h4 className="backgroundPerson">
                              Entrepreneurs & Business Owners
                            </h4>
                            <p className="" style={{ fontSize: "14px" }}>
                              Business owners who want to effectively market
                              their products or services online.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Flexible Learning Options start */}
        {/* what is your gain */}
        <div className="container mt-4 mb-4">
          <div className="row">
            <div className="col-12">
              {/* <!-- Start Single Item --> */}
              <div className="item">
                <div className="row align-items-center">
                  {/* IMAGE SECTION */}
                  <div
                    className="col-12 col-lg-5 text-center mb-4 mb-lg-0"
                    data-aos="fade-down"
                  >
                    <img
                      className="whatyougain img-fluid"
                      alt=""
                      style={{
                        maxWidth: "100%",
                        height: "auto",
                      }}
                      src={require("../../assets/images/Services/Digital Marketing/person-office-analyzing-checking-finance-graphs.webp")}
                    />
                  </div>

                  {/* CONTENT SECTION */}
                  <div
                    className="col-12 col-lg-7 mb-4 mt-0 mt-lg-5"
                    data-aos="fade-up"
                    style={{
                      paddingLeft: "15px",
                      paddingRight: "15px",
                    }}
                  >
                    <h2>What You’ll Gain</h2>

                    <h3 className="text-danger">
                      By the end of the program, you’ll have
                    </h3>

                    <p>
                      A Curated Skill Set v Expertise in niche areas that are
                      critical to your industry’s future.
                    </p>

                    <h3>Learning outcomes</h3>

                    <ul style={{ paddingLeft: "0", listStyle: "none" }}>
                      {[
                        "A solid understanding of digital marketing fundamentals and advanced techniques.",
                        "Practical experience with digital marketing tools and platforms..",
                        "The ability to create and execute successful digital marketing campaigns.",
                        "Insights into the latest trends and best practices in digital marketing.",
                        "A professional network of peers and industry experts.",
                        "A recognized certification to boost your career.",
                        "Skills and knowledge to facilitate a seamless transition into a digital marketing career, opening new opportunities in a dynamic industry.",
                      ].map((text, index) => (
                        <li
                          key={index}
                          className="d-flex align-items-start mb-2"
                        >
                          <i
                            className="fa-regular fa-circle-check text-danger"
                            style={{ marginTop: "4px" }}
                          ></i>
                          <span
                            className="mx-2"
                            style={{
                              fontSize: "14px",
                              lineHeight: "1.6",
                            }}
                          >
                            {text}
                          </span>
                        </li>
                      ))}
                    </ul>

                    <div className="bottom-info align-left"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- End Single Item -->*}}
            {/* what is your gain */}
        {/* modal code start */}
        {isModalOpen && (
          <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ marginTop: "30px" }}>
              <span className="close text-end" onClick={closeModal}>
                &times;
              </span>
              <h2>Course Details</h2>
              <form>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      id="student_name"
                      name="student_name"
                      value={formValues.student_name}
                      onChange={handleChange}
                      required
                    />
                    <label>Name</label>
                    {errors.student_name && (
                      <div className="text-danger">{errors.student_name}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      id="email"
                      name="email"
                      value={formValues.email}
                      onChange={handleChange}
                      required
                    />
                    <label>Email</label>
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="tel"
                      placeholder=""
                      id="mobile_no"
                      name="mobile_no"
                      value={formValues.mobile_no}
                      onChange={handleChange}
                      required
                    />
                    <label>Mobile</label>
                    {errors.mobile_no && (
                      <div className="text-danger">{errors.mobile_no}</div>
                    )}
                  </div>

                  <div className="floating-label">
                    <select
                      id="location"
                      name="location"
                      className="form-select"
                      value={formValues.location}
                      onChange={handleChange}
                    >
                      <option value="">Select Location</option>
                      <option value="Salem">Salem</option>
                      <option value="Erode">Erode</option>
                      <option value="Others">Others</option>
                    </select>
                    {errors.location && (
                      <div className="text-danger">{errors.location}</div>
                    )}
                  </div>

                  {showOtherLocationField && (
                    <div className="mb-3">
                      <input
                        type="text"
                        id="other_location"
                        name="other_location"
                        className="form-control"
                        placeholder="Enter Your Location"
                        value={formValues.other_location || ""}
                        onChange={handleChange}
                      />
                      {errors.location && (
                        <div className="text-danger">{errors.location}</div>
                      )}
                    </div>
                  )}

                  <div className="floating-label">
                    <input
                      type="text"
                      className="form-control"
                      name="Prefered_course"
                      value={isCourseData || formValues.Prefered_course || ""}
                      disabled // Disable input to prevent editing
                    />
                    <label>Preferred Course</label>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <p
                        className="btn btn-success"
                        onClick={handleSendMessage}
                      >
                        send
                      </p>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
        {isPopupOpen && (
          <div className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ marginTop: "30px" }}>
              <span
                className="close text-danger text-end"
                onClick={() => setIsPopupOpen(false)}
              >
                &times;
              </span>
              <h2>Download File</h2>

              <p>Click the button below to download the file:</p>
              <button className="btn btn-success" onClick={handleDownload}>
                Download
              </button>
            </div>
          </div>
        )}
        {/* modal code end */}
      </div>
    </>
  );
}

export default DigitalMarketing;
